import { create } from "apisauce";

const BASE_URL = process.env.REACT_APP_FILESTORE_API_URL;

const fileStoreAPI = create({
	baseURL: BASE_URL,
});
fileStoreAPI.axiosInstance.interceptors.request.use(async (config) => {
	config.headers.email=window?.authProvider?.account?.userName
	if (window.access_token) {
		console.warn("Found access token", window.access_token);
		config.headers.Authorization = `Bearer ${window.access_token}`;
	} else if (window.id_token) {
		config.headers.Authorization = `Bearer ${window.id_token}`;
	} else if (window.authProvider) {
		const token = await window.authProvider.getAccessToken();
		config.headers.Authorization = `Bearer ${token.accessToken}`;
	}
	console.warn("config", config);
	return config;
});
export { fileStoreAPI };

export const FileStoreApi = {

};
